/* AtopicV — Neubau.

   Das einzige Skript der neuen Startseite: ein Beobachter, der Elemente
   auftauchen lässt, sobald sie in den Blick kommen.

   Bewusst ohne GSAP. Die Seite hat genau einen Effekt, und der ist zwei
   CSS-Eigenschaften groß — dafür eine Animationsbibliothek zu starten
   wäre Ballast. Fällt das Skript aus, bleibt der Endzustand stehen
   (siehe .atv2-auf in atv2.css), die Seite ist also ohne JS vollständig.

   Der Scroll-Container wechselt bei 990px zwischen .page-wrapper und dem
   Fenster. IntersectionObserver ist davon nicht betroffen, solange
   `root: null` bleibt: der Browser nimmt dann den nächsten scrollenden
   Vorfahren selbst. Genau deshalb hier kein eigener root. */

(function () {
  "use strict";

  var ZIEL = ".atv2-auf";

  function sofortZeigen() {
    document.querySelectorAll(ZIEL).forEach(function (el) {
      el.classList.add("ist-da");
    });
  }

  /* Ohne Beobachter oder bei reduzierter Bewegung: alles direkt sichtbar. */
  if (
    !("IntersectionObserver" in window) ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", sofortZeigen);
    } else {
      sofortZeigen();
    }
    return;
  }

  function starten() {
    var beobachter = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (eintrag) {
          if (!eintrag.isIntersecting) return;
          eintrag.target.classList.add("ist-da");
          beobachter.unobserve(eintrag.target);
        });
      },
      {
        /* 12% Vorlauf: das Element ist schon ein Stück im Bild, bevor es
           auftaucht. Sonst beginnt die Blende erst, wenn man es längst
           sieht, und wirkt wie ein Nachzügler. */
        rootMargin: "0px 0px -12% 0px",
        threshold: 0.01,
      },
    );

    document.querySelectorAll(ZIEL).forEach(function (el) {
      beobachter.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", starten);
  } else {
    starten();
  }
})();

/* Stille Videos (lebendes Portrait, Beweisfenster): spielen nur im Bild und
   nur, wenn keine reduzierte Bewegung gewünscht ist. Kein autoplay-Attribut —
   das Poster ist der Grundzustand, Bewegung wird additiv daraufgelegt. */
(function () {
  "use strict";

  /* WCAG 2.2.2 „Pause, Stop, Hide" (Stufe A), 03.09.: Diese Videos tragen alle
     `loop` und stehen neben lesbarem Text — Hero hinter der Headline, der
     Produktloop direkt neben Preis und Kaufknopf. Die Fuenf-Sekunden-Ausnahme
     der Richtlinie greift NUR bei Bewegung, die von selbst aufhoert; ein Loop
     laeuft per Definition endlos. Ohne Bedienung zum Anhalten ist das ein
     Verstoss gegen Stufe A, unabhaengig davon, ob das BFSG fuer diesen Shop
     gilt (nach der Kleinstunternehmen-Schwelle vermutlich nicht).

     Weil alle Zierbilder ohnehin ueber denselben Haken laufen, reicht EINE
     Bedienung fuer die ganze Seite statt eines Knopfes je Video. Die
     Entscheidung bleibt gespeichert — wer Bewegung abstellt, will das nicht
     auf jeder Seite neu tun. */
  var SPEICHER = "atv-bewegung";

  function willRuhe() {
    try {
      return localStorage.getItem(SPEICHER) === "aus";
    } catch (e) {
      return false;
    }
  }

  function merken(aus) {
    try {
      localStorage.setItem(SPEICHER, aus ? "aus" : "an");
    } catch (e) {
      /* privater Modus */
    }
  }

  function schalterBauen(videos, angehalten, beimUmschalten) {
    var knopf = document.createElement("button");
    knopf.type = "button";
    knopf.className = "atv-bewegung";
    knopf.innerHTML =
      '<span class="atv-bewegung__zeichen" aria-hidden="true"></span>' +
      '<span class="atv-bewegung__wort"></span>';
    var wort = knopf.querySelector(".atv-bewegung__wort");

    function beschriften() {
      var text = angehalten ? "Bewegung fortsetzen" : "Bewegung anhalten";
      wort.textContent = text;
      knopf.setAttribute("aria-label", text);
      knopf.dataset.ruhe = angehalten ? "1" : "0";
    }

    knopf.addEventListener("click", function () {
      angehalten = !angehalten;
      merken(angehalten);
      beschriften();
      beimUmschalten(angehalten);
    });

    beschriften();
    document.body.appendChild(knopf);
  }

  function starten() {
    var videos = [].slice.call(document.querySelectorAll("[data-atv2-video]"));
    if (!videos.length) {
      return;
    }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    var angehalten = willRuhe();

    function abspielen(v) {
      if (angehalten) {
        return;
      }
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {});
      }
    }

    if (!("IntersectionObserver" in window)) {
      videos.forEach(abspielen);
    } else {
      var imBild = [];
      var beobachter = new IntersectionObserver(
        function (eintraege) {
          eintraege.forEach(function (e) {
            var v = e.target;
            var i = imBild.indexOf(v);
            if (e.isIntersecting) {
              if (i === -1) {
                imBild.push(v);
              }
              abspielen(v);
            } else {
              if (i !== -1) {
                imBild.splice(i, 1);
              }
              if (!v.paused) {
                v.pause();
              }
            }
          });
        },
        { rootMargin: "15% 0px" },
      );
      videos.forEach(function (v) {
        beobachter.observe(v);
      });
      videos = imBild;
    }

    schalterBauen(videos, angehalten, function (ruhe) {
      angehalten = ruhe;
      /* Anhalten trifft ALLE, Fortsetzen nur die gerade sichtbaren — sonst
         liefen Videos weit ausserhalb des Bildes unnoetig weiter. */
      if (ruhe) {
        document.querySelectorAll("[data-atv2-video]").forEach(function (v) {
          if (!v.paused) {
            v.pause();
          }
        });
      } else {
        videos.forEach(abspielen);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", starten);
  } else {
    starten();
  }
})();

/* ── Echte Scrollerbreite als --atv-breite (05.09.) ────────────────────────
   Die beiden randlosen Baender (atv-weite, atv2-story__naht) brechen mit
   `width: 100vw; margin-inline: calc(50% - 50vw)` aus der zentrierten Bahn
   aus. 100vw zaehlt die Scrollbar aber MIT: gemessen auf 1440 px stand die
   Weite-Section 1440 px breit in einem 1430 px breiten Scroller, sass bei
   left = -5 px und machte die ganze Seite seitlich schiebbar. Auf macOS faellt
   das nicht auf (Overlay-Scrollbars), auf Windows bei jedem Besucher.

   CSS kann die Scrollbarbreite nicht messen, deshalb hier: die Variable traegt
   die Inhaltsbreite des tatsaechlichen Scrollers — ab 990 px .page-wrapper,
   darunter das Fenster (siehe reference-scroller-ist-page-wrapper). Faellt das
   Skript aus, greift der Rueckfall 100vw im CSS: dann steht wieder der alte
   Zustand, nicht schlechter als vorher. */
(function () {
  "use strict";

  function breiteSetzen() {
    var wrapper = document.querySelector(".page-wrapper");
    var breit =
      wrapper && wrapper.scrollHeight > wrapper.clientHeight
        ? wrapper.clientWidth
        : document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--atv-breite", breit + "px");
  }

  breiteSetzen();
  window.addEventListener("resize", breiteSetzen);
  window.addEventListener("load", breiteSetzen);
})();
